import { useQuery } from '@tanstack/react-query';
import { provinceApi } from '../../../services';
import { ChoroplethDataSchema } from '../../../schemas/chartSchema';
import {
	createStatsQueryHook,
	createChartQueryHook,
	type StatsQueryParams,
	type ChartQueryParams,
} from '../../../hooks';

export type UseProvincesQueryParams = StatsQueryParams;
export type UseProvincesChartParams = ChartQueryParams;

const PROVINCE_MERGED_FILTER_KEYS = ['query', 'years', 'maKhoa', 'maNganh', 'maTinh'] as const;

export const useMergedProvincesQuery = createStatsQueryHook({
	entityKey: 'provinces-merged',
	apiFn: (params) => provinceApi.getMergedProvinceStats(params),
	filterKeys: PROVINCE_MERGED_FILTER_KEYS,
});

export const useMergedProvincesChartQuery = createChartQueryHook({
	entityKey: 'provinces-merged',
	apiFn: (params) => provinceApi.getMergedNivoLineChartData(params),
	filterKeys: PROVINCE_MERGED_FILTER_KEYS,
});

interface UseProvincesChoroplethParams {
	selectedYear: number | null;
	selectedFaculty?: string | null;
}

export const useMergedProvincesChoroplethQuery = (params: UseProvincesChoroplethParams) => {
	return useQuery({
		queryKey: ['provinces', 'choropleth-merged', params.selectedYear, params.selectedFaculty],
		queryFn: async () => {
			const searchParams = new URLSearchParams();
			if (params.selectedYear !== null) {
				searchParams.append('years', params.selectedYear.toString());
			}
			if (params.selectedFaculty) {
				searchParams.append('maKhoa', params.selectedFaculty);
			}
			const response = await provinceApi.getMergedProvinceChoroplethData(searchParams);
			return ChoroplethDataSchema.parse(response.data);
		},
		enabled: true,
		retry: 1,
		refetchOnWindowFocus: false,
	});
};